import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=3c8e067c&scoped=true"
import script from "./searchResult.vue?vue&type=script&lang=ts"
export * from "./searchResult.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./searchResult.vue?vue&type=style&index=0&id=3c8e067c&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3c8e067c",
  "bb6517e2"
  
)

export default component.exports